/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_In_TitleInputs */

const en_common_sign_sign_in_title = /** @type {(inputs: Common_Sign_Sign_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Common_Sign_Sign_In_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_in_title = /** @type {((inputs?: Common_Sign_Sign_In_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_In_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_sign_in_title(inputs)
});
export { common_sign_sign_in_title as "common.sign.sign_in_title" }